import * as Icon from "@ant-design/icons";
import { Modal, Col, Form, Row, Flex } from "antd";
import { ColumnsType } from "antd/es/table";
import Search from "antd/lib/input/Search";
import { useEffect } from "react";
import { AtivoModel } from "../../models/ativoModel";
import { GrupoPlanoContaFinanceiroModel } from "../../models/grupoPlanoContaFinanceiro/grupoPlanoContaFinanceiroModel";
import { setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { atualizarGrupoPlanoContaFinanceiroAtivo, buscarGrupoPlanoContaFinanceiro, deletarGrupoPlanoContaFinanceiro } from "../../services/grupoPlanoContaFinanceiroService";
import { useAppSelector, useAppDispatch } from "../../util/hooks";
import CadastroGrupoPlanoContaFinanceiro from "./modals/cadastrar";
import {
  setBuscaGrupoPlanoContaFinanceiro,
  setEntityGrupoPlanoContaFinanceiro,
  setModalCadastrarGrupoPlanoContaFinanceiro,
  setModalDeletarGrupoPlanoContaFinanceiro,
} from "../../redux/slices/grupoPlanoContaFinanceiro/grupoPlanoContaFinanceiroSlice";
import dayjs from "dayjs";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";
import AcoesComponent from "../../components/table/acoesComponent";
import { ButtonComponent } from "../../components/button/cadastrar";
import TableComponent from "../../components/table/tableComponent";
import MensagemModal from "../../components/modal/mensagem";
import { SwitchComponent } from "../../components/button/switch";

dayjs.locale("pt-br");

const GrupoPlanoContaFinanceiro = () => {
  //estados globais
  const grupoPlanoContaFinanceiroState = useAppSelector((state) => state.grupoPlanoContaFinanceiro);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();
  const editar = Object.values(grupoPlanoContaFinanceiroState.entity).length !== 0;

  useEffect(() => {
    dispatch(setTitle("GRUPO DE PLANO DE CONTA FINANCEIRO"));
    dispatch(buscarGrupoPlanoContaFinanceiro(grupoPlanoContaFinanceiroState.busca));
    form.setFieldsValue({ pesquisar: grupoPlanoContaFinanceiroState.busca });
  }, []);

  const goCadastrar = () => {
    dispatch(setEntityGrupoPlanoContaFinanceiro({}));
    dispatch(setModalCadastrarGrupoPlanoContaFinanceiro(true));
  };

  const goEditar = (value: GrupoPlanoContaFinanceiroModel) => {
    dispatch(setEntityGrupoPlanoContaFinanceiro(value));
    dispatch(setModalCadastrarGrupoPlanoContaFinanceiro(true));
  };

  const closeModalCadastrar = () => {
    dispatch(setModalCadastrarGrupoPlanoContaFinanceiro(false));
  };

  const goDeletar = (value: GrupoPlanoContaFinanceiroModel) => {
    dispatch(setEntityGrupoPlanoContaFinanceiro(value));
    dispatch(setModalDeletarGrupoPlanoContaFinanceiro(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarGrupoPlanoContaFinanceiro(false));
  };

  const onSearch = (value: string) => {
    dispatch(setBuscaGrupoPlanoContaFinanceiro(value));
    dispatch(buscarGrupoPlanoContaFinanceiro(value));
  };

  const onChangeAtivo = (value: GrupoPlanoContaFinanceiroModel) => {
    let args: AtivoModel = {
      id: value.id,
      ativo: !value.ativo,
    };
    dispatch(atualizarGrupoPlanoContaFinanceiroAtivo({ value: args, busca: grupoPlanoContaFinanceiroState.busca }));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const columns: ColumnsType<GrupoPlanoContaFinanceiroModel> = [
    {
      title: "DENOMINAÇÃO",
      dataIndex: "denominacao",
      sorter: (a, b) => a.denominacao.localeCompare(b.denominacao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "ABREVIAÇÃO",
      dataIndex: "abreviacao",
      align: "center",
      sorter: (a, b) => a.abreviacao.localeCompare(b.abreviacao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "DATA DE CRIAÇÃO",
      dataIndex: "dataCriacao",
      align: "center",
      render: (_, record) => <>{record.dataCriacao && dayjs(record.dataCriacao).format("DD/MM/YYYY")}</>,
    },
    {
      title: "ATIVO",
      dataIndex: "ativo",
      align: "center",
      filters: [
        {
          text: "Ativo",
          value: "true" as any,
        },
        {
          text: "Inativo",
          value: "false" as any,
        },
      ],
      onFilter: (value: any, record: any) => record.ativo.toString().includes(value),
      defaultFilteredValue: ["true" as any],
      render: (_, record) => <SwitchComponent onChange={() => onChangeAtivo(record)} checked={record.ativo} />,
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical" form={form}>
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              <Form.Item label="Pesquisar" name="pesquisar">
                <Search allowClear placeholder="Denominação" onSearch={onSearch} className="searchInput" enterButton style={{ width: 300 }} />
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="flex-end">
              <ButtonComponent onClick={goCadastrar} />
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent data={grupoPlanoContaFinanceiroState.list} columns={columns} loading={grupoPlanoContaFinanceiroState.loading} />
      <Modal
        title={editar ? "EDITAR GRUPO DE PLANO DE CONTA FINANCEIRO" : "NOVO GRUPO DE PLANO DE CONTA FINANCEIRO"}
        centered
        width={750}
        open={grupoPlanoContaFinanceiroState.modalCadastrar}
        closable={false}
        onCancel={closeModalCadastrar}
        footer={null}
        destroyOnHidden
      >
        <CadastroGrupoPlanoContaFinanceiro />
      </Modal>
      <Modal
        title={"REMOVER GRUPO DE PLANO DE CONTA FINANCEIRO"}
        centered
        width={450}
        open={grupoPlanoContaFinanceiroState.modalDeletar}
        closable={false}
        onCancel={closeModalDeletar}
        footer={null}
        destroyOnHidden
      >
        <MensagemModal
          text="Deseja remover o grupo de plano de conta financeiro?"
          action={deletarGrupoPlanoContaFinanceiro({ value: grupoPlanoContaFinanceiroState.entity.id, busca: grupoPlanoContaFinanceiroState.busca })}
          close={setModalDeletarGrupoPlanoContaFinanceiro(false)}
        />
      </Modal>
    </Flex>
  );
};

export default GrupoPlanoContaFinanceiro;
